import React from 'react';
import { MeshGradientBackground } from './components/MeshGradientBackground';
import { Hero } from './components/Hero';
import { FeaturesSection } from './components/FeaturesSection';
import { PricingSection } from './components/PricingSection';
import { Testimonial } from './components/Testimonial';
import { Footer } from './components/Footer';
export function App() {
  return <main className="min-h-screen w-full relative bg-slate-950 text-white selection:bg-emerald-500/30" data-id="element-0">
      <MeshGradientBackground data-id="element-1" />

      {/* Navigation Placeholder (Simple) */}
      <nav className="fixed top-0 left-0 right-0 z-50 px-6 py-4 flex justify-between items-center backdrop-blur-md bg-slate-950/50 border-b border-white/5" data-id="element-2">
        <div className="flex items-center gap-2" data-id="element-3">
          <div className="w-8 h-8 rounded-lg bg-gradient-to-br from-emerald-400 to-emerald-600 flex items-center justify-center font-bold text-white shadow-lg shadow-emerald-500/20" data-id="element-4">
            J
          </div>
          <span className="text-xl font-bold tracking-tight" data-id="element-5">Jeucapital</span>
        </div>
        <div className="hidden md:flex items-center gap-8 text-sm font-medium text-slate-300" data-id="element-6">
          <a href="#" className="hover:text-white transition-colors" data-id="element-7">
            Funkcje
          </a>
          <a href="#" className="hover:text-white transition-colors" data-id="element-8">
            Cennik
          </a>
          <a href="#" className="hover:text-white transition-colors" data-id="element-9">
            O nas
          </a>
          <button className="px-4 py-2 rounded-full bg-white/10 hover:bg-white/20 text-white transition-colors border border-white/10" data-id="element-10">
            Zaloguj się
          </button>
        </div>
      </nav>

      <div className="flex flex-col gap-12 md:gap-24" data-id="element-11">
        <Hero data-id="element-12" />
        <FeaturesSection data-id="element-13" />
        <PricingSection data-id="element-14" />
        <Testimonial data-id="element-15" />
      </div>

      <Footer data-id="element-16" />
    </main>;
}